module.exports = __webpack_public_path__ + "img/gq19.229736d4.png";